module.exports = __webpack_public_path__ + "img/SZ.21ceca9c.png";